import { render } from "./referee-change-password.vue?vue&type=template&id=332e0b8e&scoped=true"
import script from "./referee-change-password.vue?vue&type=script&lang=js"
export * from "./referee-change-password.vue?vue&type=script&lang=js"

import "./referee-change-password.vue?vue&type=style&index=0&id=332e0b8e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-332e0b8e"]])

export default __exports__